<template>
<div class="swaychat-modal swaychat-fadeInUp">
  <div class="swaychat-modal-content swaychat-advanced-rating swaychat-form">
    <form novalidate @submit.prevent="save">
      <div class="swaychat-advanced-rating-questions">
        <div class="swaychat-rate">
          <div class="swaychat-rate-label">
            <h5>{{ lang.provide_feedback }}</h5>
          </div>
          <hr>
        </div>

        <!--Questions-->
        <div v-for="(item,index) in items" v-show="active == index" class="swaychat-row swaychat-advanced-rating-item swaychat-fadeInUp">
          <h5>{{ item.label }}</h5>
          <div class="swaychat-advanced-rating-wrapper" :style="{
            'border-color': getPrimaryBg
            }">
            <table>
              <tr>
                <td v-for="ra in values" :style="{
                  'border-color': getPrimaryBg
                  }">
                  <label>
                    <input type="radio" @click="delayedNext" v-model="data[item.key]" :name="item.key" :value="ra"><span :style="{
                      'background-color': data[item.key] == ra ? getPrimaryBg : ''
                      }">{{ ra }}</span>
                  </label>
                </td>
              </tr>
            </table>
          </div>
          <div class="swaychat-advanced-rating-question-label">
            <span class="swaychat-left-label">{{ item.min }}</span>
            <span class="swaychat-right-label">{{ item.max }}</span>
          </div>
        </div>
        <!--Questions-->

        <div id="swaychat-advanced-rating-comment"
          class="swaychat-row swaychat-advanced-rating-item swaychat-fadeInUp"
          v-show="active == items.length"
        >
          <textarea name="comment" v-model="comment" :placeholder="getLang.leave_comment"></textarea>
        </div>
      </div>

      <div class="swaychat-row swaychat-advanced-rating-actions">

        <div class="swaychat-section-controls">
          <div class="swaychat-arrow-controls swaychat-arrow-previous" @click="prev()" title="Previous Question">Previous</div>
          <div class="swaychat-page-indicator">
            <ul>
              <li v-for="(item,index) in items" @click="active = index" :class="{
                'swaychat-indicator-active': index == active
                }"><span>{{ index }}</span></li>
              <li @click="active = items.length" :class="{
                'swaychat-indicator-active': active == items.length
                }"><span>{{ items.length }}</span></li>
            </ul>
          </div>
          <div class="swaychat-arrow-controls swaychat-arrow-next" @click="next()" title="Next Question">Next</div>
        </div>

        <div class="swaychat-columns-half swaychat-columns">
          <button-form-component primary="true" :label="lang.send"></button-form-component>
        </div>
        <div class="swaychat-columns-half swaychat-columns">
          <button-form-component type="button" outline="true" @click="cancel" :label="lang.cancel"></button-form-component>
        </div>
      </div>

    </form>
  </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import ButtonFormComponent from './input/ButtonFormComponent.vue'

export default {
  components: {
    ButtonFormComponent
  },
  data() {
    return {
      active: 0,
      timeout: null,
      values: [1,2,3,4,5],
      data: {
        q1: 0,
        q2: 0,
        q3: 0,
        q4: 0
      },
      comment: ''
    }
  },
  computed: {
    items() {
      let items = []
      let order = this.getSettings.advance_rating.order
      let qs = this.getSettings.advance_rating.qs

      for (let i = 0; i < order.length; i++)
        if (qs[order[i]].visible)
          items.push({
            key: order[i],
            ...qs[order[i]]
          })

      return items
    },
    lang() {
      return this.getSettings.advance_rating.language
    },
    ...mapGetters([
      'getSettings',
      'getLang',
      'getPrimaryBg'
    ])
  },
  watch: {
    items() {
      if (this.active >= this.items.length)
        this.active = this.items.length - 1
    },
  },
  methods: {
    save() {

        let items = this.items
        for (let i = 0; i < items.length; i++ )
          if (items[i].required &&
            !this.data[items[i].key]
          ) {
            this.active = i
            return
          }

        this.$store.dispatch('submitAdvanceRate', {
          data: this.data,
          comment: this.comment
        })

    },
    delayedNext() {
      clearTimeout(this.timeout)
      this.timeout = setTimeout(this.next, 500)
    },
    next() {
      this.active += 1
      if (this.active > this.items.length)
        this.active = 0
    },
    prev() {
      this.active -= 1
      if (this.active < 0)
        this.active = this.items.length
    },
    cancel() {
      this.$store.dispatch('cancelEnd')
    }
  }
}

</script>
